// Getter
export const GETTERS_QUERY_RESULTS_LIST = "GETTERS_QUERY_RESULTS_LIST";
export const GETTERS_CHART_DATA = "GETTERS_CHART_DATA";
export const GETTERS_CHART_RAW_DATA = "GETTERS_CHART_RAW_DATA";
export const GETTERS_INCENTIVE_MET_DATA = "GETTERS_INCENTIVE_MET_DATA";
export const GETTERS_WELLMETRIC_PARTICIPANTS_DATA =
  "GETTERS_WELLMETRIC_PARTICIPANTS_DATA";
export const GETTERS_DUMMY_CHART_DATA = "GETTERS_DUMMY_CHART_DATA";
export const GETTER_RISK_FACTORS_DATA = "GETTER_RISK_FACTORS_DATA";
export const GETTERS_LAST_TIME_DATA = "GETTERS_LAST_TIME_DATA";
export const GETTER_MODALITY_BY_TYPE_DATA = "GETTER_MODALITY_BY_TYPE_DATA";

// action
export const ACTION_GET_QUERY_RESULTS_LIST = "ACTION_GET_QUERY_RESULTS_LIST";
export const ACTION_GET_CHART_DATA = "ACTION_GET_CHART_DATA";
export const ACTION_GET_CHART_RAW_DATA = "ACTION_GET_CHART_RAW_DATA";
export const ACTION_GET_INCENTIVE_MET_DATA = "ACTION_GET_INCENTIVE_MET_DATA";
export const ACTION_GET_WELLMETRIC_PARTICIPANTS_DATA =
  "ACTION_GET_WELLMETRIC_PARTICIPANTS_DATA";
export const ACTION_GET_DUMMY_CHART_DATA = "ACTION_GET_DUMMY_CHART_DATA";
export const ACTION_GET_RISK_FACTORS_DATA = "ACTION_RISK_FACTORS_DATA";
export const ACTION_GET_LAST_TIME_DATA = "ACTION_GET_LAST_TIME_DATA";
export const ACTION_GET_MODALITY_BY_TYPE_DATA =
  "ACTION_GET_MODALITY_BY_TYPE_DATA";

// Mutation
export const MUTATION_SET_QUERY_RESULTS_LIST = "MUTATION_SET_UERY_RESULTS_LIST";
export const MUTATION_SET_CHART_DATA = "MUTATION_SET_CHART_DATA";
export const MUTATION_SET_CHART_RAW_DATA = "MUTATION_SET_CHART_RAW_DATA";
export const MUTATION_SET_INCENTIVE_MET_DATA =
  "MUTATION_SET_INCENTIVE_MET_DATA";
export const MUTATION_SET_WELLMETRIC_PARTICIPANTS_DATA =
  "MUTATION_SET_WELLMETRIC_PARTICIPANTS_DATA";
export const MUTATION_SET_DUMMY_CHART_DATA = "MUTATION_SET_DUMMY_CHART_DATA";
export const MUTATION_SET_RISK_FACTORS_DATA = "MUTATION_SET_RISK_FACTORS_DATA";
export const MUTATION_SET_LAST_TIME_DATA = "MUTATION_SET_LAST_TIME_DATA";
export const MUTATION_SET_MODALITY_BY_TYPE_DATA =
  "MUTATION_SET_MODALITY_BY_TYPE_DATA";

// Query Result Id
export const SCREEN_COMPLETE_BY_TYPE_QUERY_ID = 85;
export const ENGAGEMENT_QUERY_ID = 81;
export const WELLMETRIC_PARTICIPANTS_QUERY_ID = 81;
export const METABOLIC_SYNDROME = 38;
export const HUMAN_PERFORMANCE_QUERY_ID = 266;
export const COACHING_ENGAGEMENTS_QUERY_ID = 37;



// WEBPACK FOOTER //
// ./src/store/modules/query_results/constants.js